import Close from '@mui/icons-material/Close'
import { DialogContent, DialogTitle, Grid, IconButton } from '@mui/material'
import { SuggestedTherapySelectMenu } from '../../../PrescriptionMakingPageComponents'

export default function PrescriptionAdviceContextForm({
  item: advice,
  setItem: setAdvice,
  saveItem,
  closeMenu,
}) {
  return (
    <>
      <DialogTitle
        sx={{ display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'center' }}
      >
        <div>
          <span>{advice?.label}</span>
        </div>
        <IconButton sx={{ flexShrink: 0 }} onClick={closeMenu}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item md={12}>
            <h5>Suggested Therapies</h5>
          </Grid>
          <Grid item md={12}>
            <SuggestedTherapySelectMenu
              isMulti={false}
              selectedTherapies={advice?.contextualData?.selectedTherapies}
              setSelectedTherapies={(value) => {
                setAdvice((prev) => ({
                  ...prev,
                  contextualData: {
                    ...prev.contextualData,
                    selectedTherapies: { ...value, title: value?.label },
                  },
                }))
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </>
  )
}
